import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';
import { z } from 'zod';

import { isAuthenticatedFn } from '@/auth/common';
import isSafeReturnUrl from '@/utils/is-safe-return-url';

export const Route = createFileRoute('/_auth')({
  validateSearch: z.object({
    returnUrl: z.string().optional(),
  }),
  head: () => ({
    meta: [{ name: 'robots', content: 'noindex, follow' }],
  }),
  beforeLoad: async ({ search }) => {
    const isAuthenticated = await isAuthenticatedFn();
    if (isAuthenticated) {
      if (search.returnUrl && isSafeReturnUrl(search.returnUrl)) {
        throw redirect({ to: search.returnUrl });
      }
      throw redirect({ to: '/' });
    }
  },
  component: () => <Outlet />,
});
